import { Component, Input } from '@angular/core';
import { OvsComponent, ApplicationConfiguration, Core, DisplaySize, DisplayServiceBase } from '../shared/core/ovs.core';
import { ResortOutlook } from '../models/presentation.model';

@Component({
    selector: 'outlook-chart',
    templateUrl: './outlook-chart.component.html'
})
export class OutlookChartComponent extends OvsComponent
{
    @Input() public chartData: ResortOutlook[];
    @Input() public selectedDate: Date;
    @Input() public chartHighlight: string = '#000';

    private _core: Core;
    private _display: DisplayServiceBase;

    public displaySize: DisplaySize = DisplaySize.None;
    public width: number;
    public columnWidth: number;
    public plotWidth: number;
    public plotOffset: number = 22;

    constructor(core: Core, display: DisplayServiceBase)
    {
        super();
        this._core = core;
        this._display = display;
    }

    protected initialize(): void
    {
        let selectedItem: ResortOutlook = this.chartData.firstOrDefault(c => c.date.getFullYear() == this.selectedDate.getFullYear() && c.date.getMonth() == this.selectedDate.getMonth());
        if (selectedItem)
            (<any>selectedItem).isSelected = true;

        this.subscribe(this._display.displaySize, (r) => this.onDisplaySizeChanged(r));
    }

    private onDisplaySizeChanged(size: DisplaySize): void
    {
        this.displaySize = size;
        if (this.displaySize == DisplaySize.ExtraLarge)
        {
            this.width = 506;
            this.columnWidth = 20;
            this.plotWidth = 40;
        }
        else if (this.displaySize == DisplaySize.Large)
        {
            this.width = 506;
            this.columnWidth = 20;
            this.plotWidth = 36;
        }
        else
        {
            this.width = 330;
            this.columnWidth = 14;
            this.plotWidth = 24;
        }
    }

    public getSelectedIndex(): number
    {
        if (!this.selectedDate)
            return -1;

        return this.chartData.findIndex(v => v.date.getFullYear() == this.selectedDate.getFullYear() && v.date.getMonth() == this.selectedDate.getMonth()); 
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-listing/outlook-chart.component.ts